import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Questionnaire } from "../Questionnarie/Questionnaire";
import { fetchQuestionPreview } from "./preview-api";
import { LegacyStyledQuestion } from "./LegacyStyledQuestion";

// Single-question preview using the legacy <Questionnaire/> shell. If the
// question has a section, we use that section's title + sort_order so the
// hero cloud title and stepper highlight match what the user sees on the
// real page. Without a section, defaults to "Question Preview" / page 1.
export default function AdminQuestionPreview() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const [lang, setLang] = useState(params.get("lang") === "ar" ? "ar" : "en");

  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (!id) return;
    fetchQuestionPreview(id)
      .then((res) => setData(res))
      .catch(() => setError("Could not load preview."));
  }, [id]);

  if (error) return <div style={{ padding: 40, textAlign: "center" }}>{error}</div>;
  if (!data) return <div style={{ padding: 40, textAlign: "center" }}>Loading preview…</div>;

  const q = data.question;
  const sec = data.section;
  const bgTitle = sec
    ? (lang === "ar" && sec.title_arabic ? sec.title_arabic : sec.title_english)
    : (lang === "ar" ? "معاينة سؤال" : "Question Preview");
  const pageNo =
    sec?.sort_order && sec.sort_order >= 1 && sec.sort_order <= 7
      ? sec.sort_order
      : 1;

  return (
    <Questionnaire
      bgTitle={bgTitle}
      pageNo={pageNo}
      Qlang={lang}
      setQLang={setLang}
      orderId={null}
      onBackClick={() => {}}
      onNextClick={() => {}}
      onSaveLaterClick={() => {}}
      storeAnswers={[]}
      formData={{}}
      setFormData={() => {}}
      questions={
        <LegacyStyledQuestion
          question={q}
          index={0}
          value={value}
          onChange={setValue}
          lang={lang}
        />
      }
    />
  );
}
